/* ==========================================================================
   FULLSTACK - theme.js
   Vanilla, sans dependance. Chaque bloc est autonome : si l'un echoue,
   les autres continuent de fonctionner.
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.FS || {};
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- utils */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /**
   * Formate un montant exactement comme le filtre `money` de Liquid, en
   * reutilisant le money_format de la boutique. Indispensable : sans cela le
   * serveur et le client affichent deux formats differents sur la meme page.
   */
  function money(cents) {
    var fmt = CFG.moneyFormat || '{{amount}}';

    function num(value, precision, thousands, decimal) {
      if (isNaN(value) || value == null) value = 0;
      var fixed = (value / 100).toFixed(precision);
      var parts = fixed.split('.');
      var head = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return head + (parts[1] ? decimal + parts[1] : '');
    }

    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return num(cents, 2, ',', '.');
        case 'amount_no_decimals': return num(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return num(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return num(cents, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return num(cents, 0, ' ', ',');
        case 'amount_with_space_separator': return num(cents, 2, ' ', ',');
        case 'amount_with_period_and_space_separator': return num(cents, 2, ' ', '.');
        default: return '';
      }
    });
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw data;
        return data;
      });
    });
  }

  function getCart() {
    return fetch((CFG.routes && CFG.routes.cart ? CFG.routes.cart : '/cart') + '.js', {
      headers: { Accept: 'application/json' }
    }).then(function (r) { return r.json(); });
  }

  /* ------------------------------------------------------- apparition doux */
  function initReveal(root) {
    var targets = $$('[data-reveal]:not(.in)', root);
    if (!targets.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.1 });

    targets.forEach(function (el, i) {
      if (!el.style.getPropertyValue('--d')) {
        var stepMs = parseInt(el.getAttribute('data-reveal-step') || '0', 10);
        if (stepMs) el.style.setProperty('--d', (i % 8) * stepMs + 'ms');
      }
      io.observe(el);
    });
  }

  /* ------------------------------------------------------ barre d'annonces */
  function initAnnounce(root) {
    $$('[data-announce]', root).forEach(function (bar) {
      var items = $$('.announce__item', bar);
      if (items.length < 2) return;

      var i = 0;
      var timer = null;
      var delay = parseInt(bar.getAttribute('data-interval') || '5000', 10);

      function show(n) {
        i = (n + items.length) % items.length;
        items.forEach(function (el, k) { el.classList.toggle('is-active', k === i); });
      }
      function start() { if (!reduce) timer = setInterval(function () { show(i + 1); }, delay); }
      function stop() { if (timer) clearInterval(timer); timer = null; }

      var prev = $('[data-announce-prev]', bar);
      var next = $('[data-announce-next]', bar);
      if (prev) prev.addEventListener('click', function () { stop(); show(i - 1); start(); });
      if (next) next.addEventListener('click', function () { stop(); show(i + 1); start(); });

      bar.addEventListener('mouseenter', stop);
      bar.addEventListener('mouseleave', start);

      show(0);
      start();
    });
  }

  /* ---------------------------------------------------------------- tiroirs */
  var openDrawer = null;

  function drawerOpen(el) {
    if (!el) return;
    openDrawer = el;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    var focusable = el.querySelector('[data-drawer-close], a, button, input');
    if (focusable) setTimeout(function () { focusable.focus(); }, 60);
  }

  function drawerClose(el) {
    el = el || openDrawer;
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
    if (openDrawer === el) openDrawer = null;
  }

  function initDrawers() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-drawer-open]');
      if (opener) {
        e.preventDefault();
        drawerOpen(document.getElementById(opener.getAttribute('data-drawer-open')));
        return;
      }
      if (e.target.closest('[data-drawer-close]') || e.target.matches('.drawer__scrim')) {
        e.preventDefault();
        drawerClose(e.target.closest('.drawer'));
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openDrawer) drawerClose(openDrawer);
    });
  }

  /* ------------------------------------------------------------ le panier */
  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });

    var list = $('[data-cart-items]');
    var empty = $('[data-cart-empty]');
    var foot = $('[data-cart-foot]');

    if (list) {
      if (!cart.items.length) {
        list.innerHTML = '';
        if (empty) empty.hidden = false;
        if (foot) foot.hidden = true;
      } else {
        if (empty) empty.hidden = true;
        if (foot) foot.hidden = false;
        list.innerHTML = cart.items.map(function (item, index) {
          var img = item.image
            ? '<img src="' + item.image.replace(/(\.[^.]*)$/, '_160x$1') + '" alt="" width="160" height="160" loading="lazy">'
            : '';
          var variant = item.variant_title && item.variant_title !== 'Default Title'
            ? '<span class="citem__variant">' + item.variant_title + '</span>' : '';
          return '' +
            '<div class="citem">' +
              '<a class="citem__media" href="' + item.url + '">' + img + '</a>' +
              '<div class="citem__body">' +
                '<a class="citem__title" href="' + item.url + '">' + item.product_title + '</a>' +
                variant +
                '<div class="citem__row">' +
                  '<div class="qty" data-cart-qty data-line="' + (index + 1) + '">' +
                    '<button type="button" data-qty-down aria-label="Retirer un article"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8h10" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" fill="none"/></svg></button>' +
                    '<input type="number" value="' + item.quantity + '" min="0" aria-label="Quantite">' +
                    '<button type="button" data-qty-up aria-label="Ajouter un article"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M8 3v10M3 8h10" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" fill="none"/></svg></button>' +
                  '</div>' +
                  '<span class="price"><span class="price__now">' + money(item.final_line_price) + '</span></span>' +
                '</div>' +
                '<button type="button" class="citem__remove" data-cart-remove="' + (index + 1) + '">Retirer</button>' +
              '</div>' +
            '</div>';
        }).join('');
      }
    }

    $$('[data-cart-total]').forEach(function (el) { el.textContent = money(cart.total_price); });

    // Jauge de livraison offerte : n'apparait que si un seuil est configure.
    var threshold = CFG.freeShipping || 0;
    var prog = $('[data-cart-progress]');
    if (prog && threshold > 0) {
      prog.hidden = false;
      var left = threshold - cart.total_price;
      var pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
      var text = $('[data-cart-progress-text]', prog);
      var fill = $('[data-cart-progress-fill]', prog);
      if (fill) fill.style.width = pct + '%';
      if (text) {
        text.innerHTML = left > 0
          ? 'Plus que <b>' + money(left) + '</b> et la livraison est offerte.'
          : '<b>Livraison offerte</b> - le seuil est atteint.';
      }
    } else if (prog) {
      prog.hidden = true;
    }
  }

  function refreshCart(open) {
    return getCart().then(function (cart) {
      renderCart(cart);
      if (open) drawerOpen(document.getElementById('cart-drawer'));
      return cart;
    });
  }

  function initCart() {
    // Ajout au panier depuis n'importe quel formulaire produit.
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-product-form]');
      if (!form) return;
      e.preventDefault();

      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.setAttribute('aria-disabled', 'true'); }

      var data = new FormData(form);
      var payload = { items: [{ id: data.get('id'), quantity: parseInt(data.get('quantity') || '1', 10) }] };

      post((CFG.routes && CFG.routes.cartAdd) || '/cart/add.js', payload)
        .then(function () { return refreshCart(true); })
        .catch(function (err) {
          var note = form.querySelector('[data-form-note]');
          if (note) {
            note.textContent = (err && err.description) || 'Ce produit ne peut pas etre ajoute.';
            note.className = 'form-note form-note--err';
          }
        })
        .then(function () {
          if (btn) btn.removeAttribute('aria-disabled');
        });
    });

    // Quantite et suppression dans le tiroir.
    document.addEventListener('click', function (e) {
      var remove = e.target.closest('[data-cart-remove]');
      if (remove) {
        e.preventDefault();
        post((CFG.routes && CFG.routes.cartChange) || '/cart/change.js', { line: parseInt(remove.getAttribute('data-cart-remove'), 10), quantity: 0 })
          .then(renderCart);
        return;
      }

      var step = e.target.closest('[data-qty-up], [data-qty-down]');
      if (!step) return;
      var box = step.closest('[data-cart-qty]');
      if (!box) return;

      e.preventDefault();
      var input = box.querySelector('input');
      var qty = parseInt(input.value || '1', 10) + (step.hasAttribute('data-qty-up') ? 1 : -1);
      post((CFG.routes && CFG.routes.cartChange) || '/cart/change.js', { line: parseInt(box.getAttribute('data-line'), 10), quantity: Math.max(0, qty) })
        .then(renderCart);
    });

    refreshCart(false);
  }

  /* ------------------------------------------------- selecteur de quantite */
  function initQtyInputs(root) {
    $$('[data-qty]', root).forEach(function (box) {
      if (box.dataset.bound) return;
      box.dataset.bound = '1';
      var input = box.querySelector('input');
      box.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        e.preventDefault();
        var min = parseInt(input.getAttribute('min') || '1', 10);
        var next = parseInt(input.value || '1', 10) + (b.hasAttribute('data-qty-up') ? 1 : -1);
        input.value = Math.max(min, next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* -------------------------------------------------------- fiche produit */
  function initProduct(root) {
    var pdp = $('[data-product]', root);
    if (!pdp) return;

    var variants = [];
    var raw = $('[data-product-variants]', pdp);
    if (raw) { try { variants = JSON.parse(raw.textContent); } catch (e) { variants = []; } }

    var form = $('[data-product-form]', pdp);
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var priceNow = $('[data-price-now]', pdp);
    var priceWas = $('[data-price-was]', pdp);
    var priceSave = $('[data-price-save]', pdp);
    var stock = $('[data-stock]', pdp);
    var submit = form ? form.querySelector('[type="submit"]') : null;
    var btnPrice = $('[data-btn-price]', pdp);

    function selected() {
      var chosen = $$('[data-option] input:checked', pdp).map(function (i) { return i.value; });
      if (!chosen.length) return variants[0];
      return variants.filter(function (v) {
        return v.options.length === chosen.length && v.options.every(function (o, k) { return o === chosen[k]; });
      })[0];
    }

    function apply() {
      var v = selected();
      if (!v) return;

      if (idInput) idInput.value = v.id;
      if (priceNow) priceNow.textContent = money(v.price);
      if (priceWas) {
        var hasCompare = v.compare_at_price && v.compare_at_price > v.price;
        priceWas.hidden = !hasCompare;
        priceWas.textContent = hasCompare ? money(v.compare_at_price) : '';
        if (priceSave) {
          priceSave.hidden = !hasCompare;
          if (hasCompare) priceSave.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
        }
      }
      if (btnPrice) btnPrice.textContent = money(v.price);

      if (stock) {
        stock.className = 'stock' + (v.available ? '' : ' stock--out');
        stock.textContent = v.available ? (stock.getAttribute('data-in') || 'En stock') : (stock.getAttribute('data-out') || 'Epuise');
      }
      if (submit) {
        submit.disabled = !v.available;
        var label = submit.querySelector('[data-btn-label]');
        if (label) label.textContent = v.available ? (submit.getAttribute('data-label-add') || 'Ajouter au panier') : (submit.getAttribute('data-label-out') || 'Epuise');
      }

      // Met a jour l'URL sans recharger : le partage du lien garde la variante.
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }

      // Bascule la galerie sur l'image de la variante si elle en a une.
      if (v.featured_media_id) {
        var slide = $('[data-slide="' + v.featured_media_id + '"]', pdp);
        if (slide) selectSlide(pdp, slide.getAttribute('data-index'));
      }
    }

    $$('[data-option] input', pdp).forEach(function (input) {
      input.addEventListener('change', apply);
    });

    // Paliers de quantite.
    $$('[data-tier]', pdp).forEach(function (tier) {
      tier.addEventListener('click', function () {
        $$('[data-tier]', pdp).forEach(function (t) { t.classList.toggle('is-active', t === tier); });
        var qty = form ? form.querySelector('input[name="quantity"]') : null;
        if (qty) qty.value = tier.getAttribute('data-tier');
      });
    });

    apply();
  }

  /* ------------------------------------------------------------- galerie */
  function selectSlide(root, index) {
    $$('[data-slide]', root).forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-index') === String(index)); });
    $$('[data-thumb]', root).forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-thumb') === String(index) ? 'true' : 'false'); });
  }

  function initGallery(root) {
    $$('[data-gallery]', root).forEach(function (g) {
      g.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-thumb]');
        if (!thumb) return;
        e.preventDefault();
        selectSlide(g.closest('[data-product]') || g, thumb.getAttribute('data-thumb'));
      });
    });
  }

  /* --------------------------------------------------- barre d'achat fixe */
  function initStickyATC() {
    var bar = $('[data-sticky-atc]');
    var anchor = $('[data-atc-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { bar.classList.toggle('is-visible', !e.isIntersecting); });
    }, { rootMargin: '-120px 0px 0px 0px' });

    io.observe(anchor);

    var trigger = $('[data-sticky-trigger]', bar);
    if (trigger) {
      trigger.addEventListener('click', function () {
        var real = $('[data-product-form] [type="submit"]');
        if (real) real.click();
      });
    }
  }

  /* ---------------------------------------------------------- ajout rapide */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var id = btn.getAttribute('data-quick-add');
      if (!id) {
        var link = btn.getAttribute('data-url');
        if (link) window.location.href = link;
        return;
      }

      btn.setAttribute('aria-disabled', 'true');
      post((CFG.routes && CFG.routes.cartAdd) || '/cart/add.js', { items: [{ id: id, quantity: 1 }] })
        .then(function () { return refreshCart(true); })
        .catch(function () {})
        .then(function () { btn.removeAttribute('aria-disabled'); });
    });
  }

  /* ------------------------------------------------------------------ boot */
  function boot(root) {
    initReveal(root);
    initAnnounce(root);
    initQtyInputs(root);
    initProduct(root);
    initGallery(root);
    initStickyATC();
  }

  function ready() {
    initDrawers();
    initQuickAdd();
    initCart();
    boot(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  // L'editeur de theme rejoue les sections.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
